/**
 * Route for `contest-promotion-manager`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ContestPromotionManagerPage } from "../features/contest-promotion-manager/ContestPromotionManagerPage";

export const contestPromotionManagerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/contest-promotion-manager",
	component: ContestPromotionManagerPage,
});

export default contestPromotionManagerRoute;
